import { render, staticRenderFns } from "./plusIntranetGoodsTabIndex.vue?vue&type=template&id=3fbafaf2"
import script from "./plusIntranetGoodsTabIndex.vue?vue&type=script&lang=js"
export * from "./plusIntranetGoodsTabIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports